import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import Router from './Router';
import '@fontsource-variable/archivo/wdth.css';
import './styles.css';
import './planner/planner.css';

const container = document.getElementById('root');
if (!container) {
  throw new Error('Missing #root element in index.html');
}

createRoot(container).render(
  <StrictMode>
    <Router />
  </StrictMode>,
);
